import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Space,
  InputNumber,
} from 'antd';
import moment from 'moment';
import DebounceSelect from '../../Forms/DebounceSelect';
import formatAmount from 'indian-currency-formatter';
import * as Config from '../../../appConfig';
import { activePeriod, disabledDate, isSunday } from '../../../utils/date';

const AddReviseConveyanceForm = ({
  conveyance,
  lookupData,
  onLookup,
  // types,
  onConveyanceSubmit,
  onCancelClick,
  fetching,
  ability,
}) => {
  const [form] = Form.useForm();

  const [selectedEmployee, setSelectedEmployee] = React.useState(
    conveyance
      ? {
          value: `${conveyance.employee.id}`,
          label: `${conveyance.employee.first_name} ${conveyance.employee.last_name} (${conveyance.employee.emp_id})`,
        }
      : {}
  );

  console.log('selectedEmployee ////', selectedEmployee);

  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{
          id: conveyance && conveyance.id,
          // conveyance_type_id:
          //   conveyance &&
          //   conveyance.conveyance_type &&
          //   conveyance.conveyance_type.id,
          // effective_from:
          //   conveyance &&
          //   conveyance.effective_from &&
          //   moment(conveyance.effective_from),
          current_amount: conveyance && conveyance.amount,
          // note: conveyance && conveyance.note,
          employee: selectedEmployee,
        }}
        onFinish={(values) =>
          onConveyanceSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Employee"
              name="employee"
              rules={[
                {
                  required: true,
                  message: 'Please input Employee!',
                },
              ]}
            >
              <DebounceSelect
                showSearch={conveyance && conveyance.id ? false : true}
                disabled={conveyance && conveyance.id ? true : false}
                defaultValue={selectedEmployee}
                value={selectedEmployee}
                placeholder="Search employee"
                data={
                  lookupData && lookupData.length
                    ? lookupData
                    : conveyance
                    ? [
                        {
                          label: `${conveyance.employee.first_name} ${conveyance.employee.last_name} (${conveyance.employee.emp_id})`,
                          value: conveyance.employee.id,
                        },
                      ]
                    : []
                }
                onLookup={onLookup}
                onChange={(newValue) => {
                  setSelectedEmployee(newValue);
                }}
                style={{
                  width: '100%',
                }}
                fetching={fetching}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Conveyance Type"
              name="conveyance_type_id"
              rules={[
                {
                  required: true,
                  message: 'Please select Conveyance Type!',
                },
              ]}
            >
              <Select placeholder="Please select">
                {types &&
                  types.map((type) => (
                    <Select.Option key={type.id} value={type.id}>
                      {type.name} ({type.code})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row> */}
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Effective From"
              name="effective_from"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) =>
                  disabledDate(
                    current,
                    freezePrevMonth,
                    currentMonth,
                    prevMonth
                  ) || isSunday(current)
                }
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Revise Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: 'Please input Amount!',
                },
              ]}
            >
              <InputNumber
                formatter={(value) => formatAmount(value)}
                parser={(value) => value.replace(/(,*)/g, '')}
                style={{
                  width: '170px',
                }}
              />
            </Form.Item>
          </Col>
          {conveyance && conveyance.id && (
            <Col xs={24} md={12}>
              <Form.Item label="Current Amount" name="current_amount">
                <InputNumber
                  formatter={(value) => formatAmount(value)}
                  parser={(value) => value.replace(/(,*)/g, '')}
                  style={{
                    width: '170px',
                  }}
                  disabled
                />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Save
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddReviseConveyanceForm;
